// extracted by mini-css-extract-plugin
export default {"container":"AddButtonFooter_container__qiVtX","button":"AddButtonFooter_button__om04H","addLabel":"AddButtonFooter_addLabel__Dj4yE"};